import * as Yup from "yup";
import { constants, errorMessages } from "../../../../../constants";

export const DealValidationSchema = Yup.object().shape({
    legalName: Yup.string()
        .matches(constants.amrPipelineName, errorMessages.restrictedInput)
        .trim()
        .required(errorMessages.required),
});
